// Logic
import { Hall } from '@weblite/ts-action/hall'
import { changeHallInfo } from '$logic/hall'
// Common
import { OptionWithTextItem } from '$common/option-with-text-item/option-with-text-item'
import { ArrowIOSIcon } from '$common/icons/arrow-ios'
import { Switch } from '$common/switch'
// Localization
import { t } from '$i18n'
import { openEditHallAccessibility } from '$logic/router'

interface Props {
  hall: Hall
  isGroup: boolean
}

export function HallSettingsOptions({ hall, isGroup }: Props) {
  return (
    <>
      <OptionWithTextItem
        primaryText={
          isGroup
            ? t('profile.hall.options.type.groupType')
            : t('profile.hall.options.type.channelType')
        }
        secondaryText={
          hall.public
            ? t('profile.hall.options.type.public')
            : t('profile.hall.options.type.private')
        }
        icon={<ArrowIOSIcon />}
        onClick={() => openEditHallAccessibility(hall.roomId)}
      />

      {isGroup && (
        <OptionWithTextItem
          primaryText={t('profile.hall.options.historyForNewMembers.title')}
          secondaryText={
            hall.showHistoryToNewMembers
              ? t('profile.hall.options.historyForNewMembers.visible')
              : t('profile.hall.options.historyForNewMembers.hidden')
          }
          icon={
            <Switch checked={hall.showHistoryToNewMembers} disabled={false} />
          }
          onClick={() =>
            changeHallInfo(hall.roomId, {
              showHistoryToNewMembers: !hall.showHistoryToNewMembers,
            })
          }
        />
      )}
    </>
  )
}
